import { DispenserDetailResponse } from '@/features/dispensers/services/schemas.ts';
import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { Trans } from '@lingui/react/macro';
import { PropertyList } from '@/common/components/property-list/PropertyList.tsx';

export interface PosInfoCardProps {
  data: DispenserDetailResponse['pos'];
}

export const PosInfoCard = ({ data }: PosInfoCardProps) => {
  const formattedAddress = !data ? null : (
    <>
      {data.street} {data.streetNumber}
      <br />
      {data.zip} {data.city}
      <br />
      {data.country}
    </>
  );
  return (
    <DetailCard title={<Trans>Point of Sale</Trans>}>
      <PropertyList>
        <PropertyList.Item label={<Trans>Name</Trans>} value={data?.name} />
        <PropertyList.Item label={<Trans>Address</Trans>} value={formattedAddress} />
      </PropertyList>
    </DetailCard>
  );
};
